export const ARCHIVE_AUDIO_CONTROL_TABLE_TOGGLE = 'ARCHIVE_AUDIO_CONTROL_TABLE_TOGGLE'
export const AUDIO_CONTROL_DIALOG_VISIBLE = 'AUDIO_CONTROL_DIALOG_VISIBLE'
export const AUDIO_CONTROL_CLEAR_FILTERS = 'AUDIO_CONTROL_CLEAR_FILTERS'
export const SELECTED_AUDIO_CONTROL_ID = 'SELECTED_AUDIO_CONTROL_ID'
export const AUDIO_CONTROL_FIELD = 'AUDIO_CONTROL_FIELD'
export const SHOW_AUDIO_CONTROL_LOADER = 'SHOW_AUDIO_CONTROL_LOADER'
export const INITIAL_AUDIO_CONTROL_DATA = 'INITIAL_AUDIO_CONTROL_DATA'
export const GET_AUDIO_CONTROLS = 'GET_AUDIO_CONTROLS'
export const GET_AUDIO_CONTROL = 'GET_AUDIO_CONTROL'
export const SET_AUDIO_CONTROL_ERROR_FIELDS = 'SET_AUDIO_CONTROL_ERROR_FIELDS'
export const GET_AUDIO_CONTROL_PAGINATION = 'GET_AUDIO_CONTROL_PAGINATION'
export const SET_AUDIO_CONTROL_CURRENT_PAGE = 'SET_AUDIO_CONTROL_CURRENT_PAGE'
export const SET_AUDIO_CONTROL_CURRENT_SIZE = 'SET_AUDIO_CONTROL_CURRENT_SIZE'
export const SHOW_AUDIO_CONTROL_DETAIL_LOADING = 'SHOW_AUDIO_CONTROL_DETAIL_LOADING'
export const SHOW_AUDIO_CONTROL_SAVE_LOADER = 'SHOW_AUDIO_CONTROL_SAVE_LOADER'
export const SET_AUDIO_CONTROL_BLOCKS = 'SET_AUDIO_CONTROL_BLOCKS'
export const ADD_AUDIO_CONTROL_BLOCK = 'ADD_AUDIO_CONTROL_BLOCK'
export const REMOVE_AUDIO_CONTROL_BLOCK = 'REMOVE_AUDIO_CONTROL_BLOCK'
export const UPDATE_AUDIO_CONTROL_BLOCK = 'UPDATE_AUDIO_CONTROL_BLOCK'
export const ADD_AUDIO_CONTROL_CONDITION = 'ADD_AUDIO_CONTROL_CONDITION'
export const REMOVE_AUDIO_CONTROL_CONDITION = 'REMOVE_AUDIO_CONTROL_CONDITION'
export const UPDATE_AUDIO_CONTROL_CONDITION = 'UPDATE_AUDIO_CONTROL_CONDITION'
export const SET_FAIL_LIST = 'SET_FAIL_LIST'
